// extracted by mini-css-extract-plugin
module.exports = {"categList":"AboutPage_categList__QFkQh","categList__itemName":"AboutPage_categList__itemName__29frn"};